import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from '@thd-olt-component-react/router';
import ConfirmDialog from '../../common/ConfirmDialog/ConfirmDialog';
import { useStore } from '../../../store/index';
import { EXP_ROUTES, JOB_POSTING_STATUS } from '../../../utils/constants';
import { JobPostingContext } from '../../../contexts/JobPostingContext';
import { composeGoBackUrlParam } from '../../../utils/go-back';

const ReopenJobPostingDialog = ({ jobPostingPage }) => {
  const navigate = useNavigate();

  const {
    jobPostingStore: {
      pendingReopenJobPostingId,
      pendingReopenJobPostingDeadlineToApply,
      toggleReopenJobPostingModal,
      updateJobPostingStatus: updateJobPostingStatusStore
    }
  } = useStore();

  const {
    updateJobPostingStatus,
    activeJobPosting
  } = useContext(JobPostingContext);

  const reOpenFromTable = (jobId) => {
    navigate(`${EXP_ROUTES.EDIT_JOB_POSTING(jobId)}${composeGoBackUrlParam()}`);
  };

  return (
    <ConfirmDialog
      headerText="Re-Open Job Posting"
      open={!!pendingReopenJobPostingId}
      onConfirm={() => {
        if (jobPostingPage) {
          if (activeJobPosting?.deadlineToApply) {
            updateJobPostingStatus(pendingReopenJobPostingId, JOB_POSTING_STATUS.ACTIVE, jobPostingPage, toggleReopenJobPostingModal, true);
          } else {
            updateJobPostingStatus(pendingReopenJobPostingId, JOB_POSTING_STATUS.ACTIVE, jobPostingPage, toggleReopenJobPostingModal, false);
          }
        } else if (pendingReopenJobPostingDeadlineToApply) {
          updateJobPostingStatusStore(pendingReopenJobPostingId, JOB_POSTING_STATUS.ACTIVE, jobPostingPage, toggleReopenJobPostingModal, true, reOpenFromTable);
        } else {
          updateJobPostingStatusStore(pendingReopenJobPostingId, JOB_POSTING_STATUS.ACTIVE, false, toggleReopenJobPostingModal, false);
        }
      }}
      onClose={() => {
        toggleReopenJobPostingModal();
      }}
      confirmTestId="confirm-reopen-job-posting"
      confirmText="Re-Open Posting"
      cancelText="Cancel"
    >
      Re-open your job posting to allow candidates to apply to this job again.
    </ConfirmDialog>
  );
};

export default observer(ReopenJobPostingDialog);
